// extracted by mini-css-extract-plugin
module.exports = {"link":"NavLink_link__3BMEy"};